import Vue from 'vue'
import Router from 'vue-router'
import storesRoutes from './storesRoutes'
import loginLogoutRoutes from './loginLogout'
import main from './main'
import categoryRoutes from './categoryRoutes'
import productRoutes from './productRoutes'
import colorRoutes from './colorRoutes'
import brandsRoutes from './brandsRoutes'
import usersRoutes from './usersRoutes'
import clientOrders from './clientOrders'
import productPricesRoutes from './productPricesRoutes'
import wholesalesRoutes from './wholesalesRoutes'
import statsRoutes from './stats'
import dailyRoutes from './daily'
import scheduleRoutes from './scheduleRoutes'
import productGroup from './productGroup'
import phonesInfoRoutes from './phonesInfoRoutes'
import complaintsRoutes from './complaintsRoutes'
import salesPlans from './salesPlans'
import serviceDataRoutes from './serviceDataRoutes'
import expensesRoutes from './expensesRoutes'
import phonesRoutes from './phonesRoutes'
import reportsRoutes from './reportsRoutes'
import phoneNames from './phoneNames'
import torreWork from './torreWorkRoutes'
import acrticlesRoutes from './articlesRoutes'
import categoryConstraintsRoutes from './categoryConstraintsRoutes'
import RoutingService from "./RoutingService"

const routingService = new RoutingService()

Vue.use(Router)

var routes = []
routes = routes.concat(main)
routes = routes.concat(loginLogoutRoutes)
routes = routes.concat(storesRoutes)
routes = routes.concat(categoryRoutes)
routes = routes.concat(productRoutes)
routes = routes.concat(colorRoutes)
routes = routes.concat(brandsRoutes)
routes = routes.concat(usersRoutes)
routes = routes.concat(clientOrders)
routes = routes.concat(productPricesRoutes)
routes = routes.concat(wholesalesRoutes)
routes = routes.concat(statsRoutes)
routes = routes.concat(dailyRoutes)
routes = routes.concat(scheduleRoutes)
routes = routes.concat(productGroup)
routes = routes.concat(phonesInfoRoutes)
routes = routes.concat(complaintsRoutes)
routes = routes.concat(salesPlans)
routes = routes.concat(serviceDataRoutes)
routes = routes.concat(expensesRoutes)
routes = routes.concat(phonesRoutes)
routes = routes.concat(reportsRoutes)
routes = routes.concat(phoneNames)
routes = routes.concat(torreWork)
routes = routes.concat(acrticlesRoutes)
routes = routes.concat(categoryConstraintsRoutes)

routes.push({
  path: '*',
  redirect: { name: 'login' }
})

const router = new Router({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  routingService.beforeRoute(to, from ,next)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js